import { CampaignSenderDomainStatus } from '../campaign_sender_domain';
import { validateEnumTranslations } from '../../safety_checks';

export const TRANSLATE_KEY_CAMPAIGN_SENDER_DOMAIN_STATUS = 'CAMPAIGN_SENDER_DOMAIN_STATUS_';

export const CampaignSenderDomainStatusTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_CAMPAIGN_SENDER_DOMAIN_STATUS}${CampaignSenderDomainStatus.PENDING}`]: 'Configuration en cours',
    [`${TRANSLATE_KEY_CAMPAIGN_SENDER_DOMAIN_STATUS}${CampaignSenderDomainStatus.DNS_PENDING}`]:
      'En cours de vérification',
    [`${TRANSLATE_KEY_CAMPAIGN_SENDER_DOMAIN_STATUS}${CampaignSenderDomainStatus.ACTIVE}`]: 'Actif',
    [`${TRANSLATE_KEY_CAMPAIGN_SENDER_DOMAIN_STATUS}${CampaignSenderDomainStatus.ERROR}`]: 'Erreur',
    [`${TRANSLATE_KEY_CAMPAIGN_SENDER_DOMAIN_STATUS}${CampaignSenderDomainStatus.DISABLED}`]: 'Retiré',
  },
};

//DONT TOUCH below this line
validateEnumTranslations(
  CampaignSenderDomainStatus,
  CampaignSenderDomainStatusTranslation,
  TRANSLATE_KEY_CAMPAIGN_SENDER_DOMAIN_STATUS,
  true,
);
